import { render } from "./InternationalCooperationView.vue?vue&type=template&id=13531196&scoped=true"
import script from "./InternationalCooperationView.vue?vue&type=script&lang=js"
export * from "./InternationalCooperationView.vue?vue&type=script&lang=js"

import "./InternationalCooperationView.vue?vue&type=style&index=0&id=13531196&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13531196"]])

export default __exports__